<template>
  <div id="content">

    <div id="about">
      <div id="plan">
        <div id="infoplan"
             v-if="$i18n.locale=='en'"
             v-html="info.remark_en"></div>
        <div id="infoplan"
             v-else
             v-html="info.remark"></div>
      </div>
    </div>
  </div>
</template>

<script>
import fetch from "@/utils/axios";
export default {
  components: {},
  name: 'About',
  data () {
    return {
      info: {},
      id: 14
    };
  },
  mounted () {
    if (this.$route.params.id)
      this.id = this.$route.params.id
    // alert(this.$route.params.id);
    // 使用
    const params = { id: this.id }; // 参数
    fetch.post("/api/ApiSystemInfo/Get", params).then(
      (res) => {
        this.info = res;
      },
      (error) => {
        alert(JSON.stringify(error));
      }
    );
  },
  methods: {
    jumppage (p) {
      if (p == '100') {
        window.open("/#/news", '_blank')
        // <li><a target="_blank"
        //          href="/#/news"><span>{{ $t("header.news")}}</span></a></li>
      } else {
        const params = { id: p }; // 参数
        fetch.post("/api/ApiSystemInfo/Get", params).then(
          (res) => {
            this.info = res;
          },
          (error) => {
            alert(JSON.stringify(error));
          }
        );
      }
    }
  }
};
</script>

<style>
#about {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
#plan {
  width: 1190px;
  margin: 20px auto auto;
}

#infoplan {
  width: 1190px;
  margin: 0px;
}
</style>



// WEBPACK FOOTER //
// src/Plan.vue